// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview {
  max-width: 200px;
}
/*CSS classes*/
.text-tabs-1{float:left;}

.text-tabs-2{
  float:right;
  text-align: right;
  width: 88%;
  /*margin-left:120px;*/
  display:block;
  position:absolute;
}

.clearer{clear:both;}

.text-tabs-decription-2{
  float:left;
  margin-left:35px;
  height: 100px;
  max-width: 470px;
}

.p-description {
  text-overflow: ellipsis; /* will make [...] at the end */
  width: 370px; /* change to your preferences */
  white-space: nowrap; /* paragraph to one line */
  overflow:hidden; /* older browsers */
}

::ng-deep lightbox gallery {
  background-color: white !important;
  min-width: 800px;
}

.lightbox {
  /* Default to hidden */
  display: none;

  /* Overlay entire screen */
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* A bit of padding around image */
  padding: 1em;

  /* Translucent background */
  background: rgba(0, 0, 0, 0.8);
}

/* Unhide the lightbox when it's the target */
.lightbox:target {
  display: block;
}

.lightbox span {
  /* Full width and height */
  display: block;
  width: 100%;
  height: 100%;

  /* Size and position background image */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

/*
.mat-success {
  background-color: #007bff;
  color: #fff;
}
*/
.example-button-row button,
.example-button-row a {
  margin-right: 8px;
}

.mat-button.mat-success,
.mat-stroked-button.mat-success {
  color: #007bff;
}
.mat-button.mat-success:hover,
.mat-stroked-button.mat-success:hover {
  background-color: #f0fff3;
}

.mat-raised-button.mat-success,
.mat-flat-button.mat-success,
.mat-fab.mat-success,
.mat-mini-fab.mat-success {
  color: #f0fff3;
  background-color: #007bff;
}

.mat-icon-button.mat-success {
  color:#007bff;
}
`, "",{"version":3,"sources":["webpack://./src/app/all/all-view-item.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA,cAAc;AACd,aAAa,UAAU,CAAC;;AAExB;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA,SAAS,UAAU,CAAC;;AAEpB;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,YAAY,EAAE,+BAA+B;EAC7C,mBAAmB,EAAE,0BAA0B;EAC/C,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;;EAEb,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;;EAET,kCAAkC;EAClC,YAAY;;EAEZ,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;;;;CAKC;AACD;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".preview {\n  max-width: 200px;\n}\n/*CSS classes*/\n.text-tabs-1{float:left;}\n\n.text-tabs-2{\n  float:right;\n  text-align: right;\n  width: 88%;\n  /*margin-left:120px;*/\n  display:block;\n  position:absolute;\n}\n\n.clearer{clear:both;}\n\n.text-tabs-decription-2{\n  float:left;\n  margin-left:35px;\n  height: 100px;\n  max-width: 470px;\n}\n\n.p-description {\n  text-overflow: ellipsis; /* will make [...] at the end */\n  width: 370px; /* change to your preferences */\n  white-space: nowrap; /* paragraph to one line */\n  overflow:hidden; /* older browsers */\n}\n\n::ng-deep lightbox gallery {\n  background-color: white !important;\n  min-width: 800px;\n}\n\n.lightbox {\n  /* Default to hidden */\n  display: none;\n\n  /* Overlay entire screen */\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  /* A bit of padding around image */\n  padding: 1em;\n\n  /* Translucent background */\n  background: rgba(0, 0, 0, 0.8);\n}\n\n/* Unhide the lightbox when it's the target */\n.lightbox:target {\n  display: block;\n}\n\n.lightbox span {\n  /* Full width and height */\n  display: block;\n  width: 100%;\n  height: 100%;\n\n  /* Size and position background image */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n/*\n.mat-success {\n  background-color: #007bff;\n  color: #fff;\n}\n*/\n.example-button-row button,\n.example-button-row a {\n  margin-right: 8px;\n}\n\n.mat-button.mat-success,\n.mat-stroked-button.mat-success {\n  color: #007bff;\n}\n.mat-button.mat-success:hover,\n.mat-stroked-button.mat-success:hover {\n  background-color: #f0fff3;\n}\n\n.mat-raised-button.mat-success,\n.mat-flat-button.mat-success,\n.mat-fab.mat-success,\n.mat-mini-fab.mat-success {\n  color: #f0fff3;\n  background-color: #007bff;\n}\n\n.mat-icon-button.mat-success {\n  color:#007bff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
